import { render, staticRenderFns } from "./CategoryRulesPage.vue?vue&type=template&id=dffcb866&scoped=true&"
import script from "./CategoryRulesPage.vue?vue&type=script&lang=js&"
export * from "./CategoryRulesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffcb866",
  null
  
)

export default component.exports